package com.vizio.redwolf.pay.model

import com.vizio.redwolf.auth.model.AccountShippingAddress
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class Order(
    @SerialName("id") val id: String,
    @SerialName("orderNumber") val orderNumber: String,
    @SerialName("orderState") val orderState: String,
    @SerialName("userState") val userState: String,
    @SerialName("orderDate") val orderDate: String,
    @SerialName("price") val price: Float,
    @SerialName("tax") val tax: Float,
    @SerialName("recyclingFee") val recyclingFee: Float,
    @SerialName("subtotal") val subtotal: Float,
    @SerialName("shipping") val shipping: Float,
    @SerialName("total") val total: Float,
    @SerialName("savings") val savings: Float,
    @SerialName("signatureRequired") val signatureRequired: Boolean,
    @SerialName("cardType") val cardType: String,
    @SerialName("cardLastFour") val cardLastFour: String,
    @SerialName("cardExpirationDate") val cardExpirationDate: String,
    @SerialName("cardImageUrl") val cardImageUrl: String,
    @SerialName("email") val email: String,
    @SerialName("billingAddress") val billingAddress: AccountShippingAddress,
    @SerialName("shippingAddress") val shippingAddress: CartAddress,
    @SerialName("lineItems") val lineItems: List<OrderItem>
)


@Serializable
data class OrderInfo(
    @SerialName("cartId") val cartId: String,
    @SerialName("creditCardNonce") val creditCardNonce: String?,
    @SerialName("creditCardToken") val creditCardToken: String?,
    @SerialName("storeCreditCard") val storeCreditCard: Boolean,
    @SerialName("ipAddress") val ipAddress: String,
    @SerialName("sessionId") val sessionId: String,
    @SerialName("signedIn") val signedIn: Boolean,
)

data class OrderRequestInfo(
    val cartId: String,
    val creditCardNonce: String? = null,
    val creditCardToken: String? = null,
    val storeCreditCard: Boolean,
    val ipAddress: String,
    val sessionId: String,
    val signedIn: Boolean,
)
